import React, { useCallback } from 'react'

import { graphql, navigate } from 'gatsby'
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews'

import Img from '../components/Img'
import { SEO } from '../components/Head'
import Button from '../components/Button'
import { Layout } from '../components/Layout'

import { getDefaultPageData } from '../utils/getDefaultPageData'

const NotFoundPage = ({ data }) => {
  if (!data) return null

  const headerArticlesData = data.headerArticles.nodes

  const { topLine, footer, header, page, activeDoc, topMenu } =
    getDefaultPageData(data, 'prismicErrorPage')

  const goBack = useCallback(() => {
    navigate(-1)
  }, [])

  return (
    <Layout
      topMenu={topMenu.data}
      footer={footer.data}
      topLine={topLine.data}
      header={{ nav: header.data.nav, articles: header.data.articles }}
      activeDocMeta={activeDoc}
      headerArticlesData={headerArticlesData}
    >
      <section className="not-found">
        <div className="container">
          {page?.background_image?.gatsbyImageData && (
            <Img
              image={page.background_image.gatsbyImageData}
              alt={page?.background_image?.alt}
              className="background-image background-image-one"
            />
          )}
          <h1 className="title">{page.code_error.text}</h1>
          <p className="description">{page.description.text}</p>
          <Button data={page} callback={goBack} />
          {page?.background_image_two?.gatsbyImageData && (
            <Img
              image={page.background_image_two.gatsbyImageData}
              alt={page?.background_image_two?.alt}
              className="background-image background-image-two"
            />
          )}
        </div>
      </section>
    </Layout>
  )
}

export const Head = ({ data }) => {
  const { page, pageContent } = getDefaultPageData(data, 'prismicErrorPage')
  return (
    <SEO
      meta={{
        title: page?.meta_title,
        description: page?.meta_description,
        image: page?.meta_image,
        type: page?.type,
        pageContent,
      }}
    />
  )
}

export const query = graphql`
  query PrismicErrorPage($id: String, $lang: String) {
    prismicErrorPage(id: { eq: $id }, lang: { eq: $lang }) {
      _previewable
      url
      type
      id
      lang
      alternate_languages {
        id
        type
        lang
      }
      data {
        meta_title {
          text
        }
        meta_image {
          url
          alt
        }
        meta_description {
          text
        }
        code_error {
          text
        }
        button_title {
          text
        }
        button_theme
        button_link {
          url
        }
        background_image_two {
          gatsbyImageData
          alt
        }
        background_image {
          gatsbyImageData
          alt
        }
        description {
          text
        }
      }
    }
    prismicTopLine(lang: { eq: $lang }) {
      ...TopLineFragment
    }
    prismicHeader(lang: { eq: $lang }) {
      data {
        articles {
          article_link {
            document {
              ... on PrismicArticlePage {
                ...ArticlePage
              }
            }
          }
        }
        nav {
          ... on PrismicSlice {
            id
            slice_type
            slice_label
          }
          ...HeaderDataNavFooter
          ...HeaderDataNavButton
          ...HeaderDataNavNavItem
        }
      }
    }
    prismicFooter(lang: { eq: $lang }) {
      data {
        body {
          ... on PrismicSlice {
            id
            slice_type
            slice_label
          }
          ...FooterDataBodyCopyright
          ...FooterDataBodyFooter
          ...FooterDataBodySocials
          ...FooterDataBodyAwards
          ...FooterDataBodyForm
        }
        body1 {
          ... on PrismicSlice {
            id
            slice_type
            slice_label
          }
          ...FooterDataBody1NavItem
        }
      }
    }
    headerArticles: allPrismicArticlePage(
      filter: {
        lang: { eq: $lang }
        data: { invisible: { eq: "no" }, type: { eq: "blog" } }
      }
      limit: 2
      sort: { first_publication_date: DESC }
    ) {
      nodes {
        ...ArticlePage
      }
    }
  }
`

export default withPrismicPreview(NotFoundPage)
